export default "__VITE_ASSET__Cy5u7cY9__"